module.exports = __webpack_public_path__ + "img/robot-service-engineer-bg.6b0a0784.png";